// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.createUser_dashboard__17yXH {
  width: calc(100% - 320px);
  position: relative;
  left: 310px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.createUser_dashboardContain__frg-z {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.createUser_bodythemedark__kzglF .createUser_dashboardContain__frg-z,
.createUser_bodythemedark__kzglF .createUser_dashboard__17yXH,
.createUser_bodythemedark__kzglF .createUser_cont2__AUUWk {
  background-Color: #0f1824;
}

.createUser_top_header__5x0WP .createUser_top_header_inner__WgBlR {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.createUser_cont2__AUUWk {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.createUser_footer__r8ySe {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.createUser_bodythemelight__xGFCq {
  background-color: #fff;
  padding-top: 90px;
}

.createUser_bodythemedark__kzglF {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.createUser_headerthemelight__9RK3i {
  background-color: #fff;
}

.createUser_headerthemedark__rbDM\\+ {
  background-color: #132337;
}

.createUser_top_header__5x0WP {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.createUser_menuthemelight__EgxpM {
  background-color: #fff;
}

.createUser_menuthemedark__e-R6\\+ {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.createUser_menulinklight__Dv14u span {
  color: #666666 !important;
}

.createUser_menulinklight__Dv14u a {
  color: #CBCBCB !important;
}

.createUser_menulinklight__Dv14u:hover span, .createUser_menulinklight__Dv14u:hover a {
  color: #fff !important;
}

.createUser_menulinkdarkSelected__84zB7 {
  background-color: #1c2e45;
  color: #3b82f6;
}

.createUser_menuthemelight__EgxpM .createUser_menulinklightSelected__34KWF {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.createUser_menulinkdark__gEw\\+k {
  color: #92afd3 !important;
}

.createUser_menulinklight__Dv14u:hover {
  color: #fff !important;
  background-color: #131F43;
}

.createUser_menulinklight__Dv14u .createUser_sub_arrow__owL-H svg path {
  stroke: #CBCBCB !important;
}

.createUser_menulinklight__Dv14u:hover .createUser_sub_arrow__owL-H svg path {
  stroke: #fff !important;
}

.createUser_menulinkdark__gEw\\+k .createUser_sub_arrow__owL-H svg path {
  stroke: #92afd3 !important;
}

.createUser_menulinkdark__gEw\\+k:hover .createUser_sub_arrow__owL-H svg path {
  stroke: #fff !important;
}

.createUser_menulinkdark__gEw\\+k:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.createUser_headinglight__pb5IY {
  color: #60677e;
}

.createUser_headingdark__\\+wZmd {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.createUser_searchboxlight__it2cD {
  background-color: #fff;
  border: none;
}

.createUser_searchboxdark__zk723 {
  background-color: #132337;
  color: #fff;
  border: none;
}

.createUser_searchboxdark__zk723::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.createUser_tableheadlight__zJuDZ {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.createUser_tableheadlight__zJuDZ th {
  color: #fff;
}

thead .createUser_tableheadlight__zJuDZ th:first-child,
thead .createUser_tableheaddark__93g9w th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .createUser_tableheadlight__zJuDZ th:last-child,
thead .createUser_tableheaddark__93g9w th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.createUser_table__\\+vT8B.createUser_table-borderless__zuaEC {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.createUser_tableheaddark__93g9w {
  background-color: #132337;
  color: #fff;
}

.createUser_table-borderless__zuaEC tr:nth-child(even) {
  background-color: #F9FAFB;
}

.createUser_table-borderless__zuaEC .createUser_left-section__m6jeo {
  padding-top: 10px;
}

.createUser_tablebodylight__RQHFo td,
.createUser_tablebodydark__\\+wUQe td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.createUser_tablebodylight__RQHFo {
  background-color: #fff;
}
.createUser_tablebodylight__RQHFo:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.createUser_tablebodydark__\\+wUQe {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.createUser_tablebodydark__\\+wUQe:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.createUser_paginationlight__vk0cl {
  color: #60677e !important;
  font-size: 13px !important;
}

.createUser_paginationdark__Xw1eA {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.createUser_formthemelight__GNCil {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.createUser_formthemedark__c2wJu {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.createUser_formthemedark__c2wJu ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.createUser_viewformlight__5iQFa {
  background-color: #f3f6f9;
}

.createUser_permissionboxlight__Xbi1l {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.createUser_permissionboxdark__tZnnH {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.createUser_errormsgclr__fZqt\\+ {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.createUser_graphclrlight__w4ooJ {
  background-color: #fff;
}

.createUser_graphclrdark__BbVKi {
  background-color: #132337;
}

/* 
Counter theme
*/
#createUser_card1bglight__0e\\+GH {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#createUser_card1bgdark__olYL6 {
  background: #392f28;
}

#createUser_card2bglight__vgbXZ {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#createUser_card2bgdark__rXsmA {
  background: #1c3238;
}

#createUser_card3bglight__WUTme {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#createUser_card3bgdark__hI9mR {
  background: #3a2434;
}

#createUser_card4bglight__1\\+mIM {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#createUser_card4bgdark__1zDPP {
  background: #2f264f;
}

#createUser_card1bgdark__olYL6 a, #createUser_card1bgdark__olYL6 p,
#createUser_card2bgdark__rXsmA a, #createUser_card2bgdark__rXsmA p,
#createUser_card3bgdark__hI9mR a, #createUser_card3bgdark__hI9mR p,
#createUser_card4bgdark__1zDPP a, #createUser_card4bgdark__1zDPP p {
  color: #fff;
}

/* 
Action button theme
*/
.createUser_actionbtnlight__DmVva {
  color: rgba(70, 71, 91, 0.8705882353);
}

.createUser_actionbtnlight__DmVva:hover {
  cursor: pointer;
}

.createUser_actionbtndark__gMi4o {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.createUser_profiledropdownlight__2lQzy {
  background-color: #fff;
}

.createUser_profiledropdowndark__Mvb9k {
  background-color: #151521;
}

.createUser_settingsection__JFGnn #createUser_addform__c-1fM.createUser_formthemedark__c2wJu .createUser_savebtn__uS9j\\+ {
  background-color: #3b82f6;
  color: #fff;
}

#createUser_addform__c-1fM.createUser_formthemedark__c2wJu .createUser_savebtn__uS9j\\+ {
  background-color: #3b82f6;
  color: #fff;
}

.createUser_profile_conatiner__RVAU1 {
  border-radius: 5px !important;
}

.createUser_bodythemedark__kzglF .createUser_ag-theme-alpine__d2lH0 .createUser_ag-row__GzqWr {
  background: #000 !important;
}

.createUser_bodythemedark__kzglF .createUser_formbtn__7DbRY {
  background-color: #3b82f6;
}

.createUser_bodythemedark__kzglF .createUser_formbtn__7DbRY:hover {
  background-color: #2563eb;
}

.createUser_bodythemedark__kzglF .createUser_resetbtn__wCOLc {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.createUser_bodythemedark__kzglF .createUser_resetbtn__wCOLc:hover {
  background-color: #3b82f6;
}

.createUser_headingdark__\\+wZmd span {
  background-color: #132337;
}

.createUser_resetbtn__wCOLc {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.createUser_resetbtn__wCOLc:hover,
.createUser_resetbtn__wCOLc:active,
.createUser_resetbtn__wCOLc:focus {
  background-color: #131F43;
  color: #fff;
}

.createUser_addBtn__2U3kk {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.createUser_addbtnlight__sZAtb {
  background-color: #38A169;
}

.createUser_addbtndark__WGuk8 {
  background-color: #3b82f6;
}

.createUser_addbtndark__WGuk8:hover {
  background-color: #2563eb;
}

.createUser_formthemedark__c2wJu label {
  color: #92afd3;
}

.createUser_addBtn__2U3kk svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.createUser_addBtn__2U3kk:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.createUser_cust_addBtn__Z-wC0.createUser_addBtn__2U3kk svg {
  top: 2px;
}

.createUser_deleteBtn__E04aD {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.createUser_deleteBtn__E04aD {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.createUser_deleteBtn__E04aD:active, .createUser_deleteBtn__E04aD:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.createUser_deleteBtn__E04aD svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.createUser_deleteBtn__E04aD:hover,
.createUser_deleteBtn__E04aD:active,
.createUser_deleteBtn__E04aD:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.createUser_confirmBtn__3LX0U {
  background-color: #131F43;
}

.createUser_confirmBtn__3LX0U:hover,
.createUser_confirmBtn__3LX0U:active,
.createUser_confirmBtn__3LX0U:focus {
  background-color: #131F43;
}

.createUser_confirmBtn__3LX0U svg {
  top: 0;
}

.createUser_delPopContainer__ernWk .createUser_modal-body__MHQGK {
  padding: 25px;
  text-align: center;
}

.createUser_delPopContainer__ernWk .createUser_delet_icon__fXzxB {
  margin-bottom: 11px;
}

.createUser_delPopContainer__ernWk p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.createUser_arrowback__lG5yY svg {
  fill: #000;
}

.createUser_bodythemedark__kzglF .createUser_arrowback__lG5yY {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.createUser_bodythemedark__kzglF .createUser_arrowback__lG5yY svg {
  fill: #3b82f6;
}

.createUser_bodythemedark__kzglF .createUser_drpdwn_btn__DhdKo {
  background-color: #132337;
}

.createUser_bodythemedark__kzglF .createUser_empname__ZhmHW {
  color: #92afd3 !important;
}

.createUser_bodythemedark__kzglF .createUser_navitemli__3afjv a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.createUser_bodythemedark__kzglF .createUser_tabnavli__rjxZW a.createUser_settingsgeneral__lu7P9,
.createUser_bodythemedark__kzglF .createUser_tabnavli__rjxZW a.createUser_settingslinks__RRBrS:hover {
  background-color: #3b82f6;
  color: #fff;
}

.createUser_bodythemedark__kzglF .createUser_tabnavli__rjxZW a.createUser_settingslinks__RRBrS {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.createUser_headerthemedark__rbDM\\+ .createUser_dropdown_menu_contain__YGsrZ {
  background-color: #1c2e45;
  color: #fff;
}

.createUser_headerthemedark__rbDM\\+ .createUser_dropdown_menu_contain__YGsrZ ul li a,
.createUser_headerthemedark__rbDM\\+ .createUser_dropdown_menu_contain__YGsrZ .createUser_dropdown_item__mYmtG,
.createUser_headerthemedark__rbDM\\+ .createUser_dropdown_menu_contain__YGsrZ .createUser_dropdown_item__mYmtG h5 {
  color: #fff;
}

.createUser_headerthemedark__rbDM\\+ .createUser_dropdown_menu_contain__YGsrZ ul li a:hover,
.createUser_headerthemedark__rbDM\\+ .createUser_dropdown_menu_contain__YGsrZ .createUser_dropdown_item__mYmtG:hover {
  background-color: #132337;
  color: #fff;
}

.createUser_dropdown_item__mYmtG:active {
  background-color: #F5F6FA;
}

.createUser_profile_arrrow_dwn__WFPyZ {
  stroke: #132337;
}

.createUser_headerthemedark__rbDM\\+ .createUser_profile_arrrow_dwn__WFPyZ {
  stroke: #fff;
}

.createUser_dateinputbox1__k6IeO input,
.createUser_dateinputbox1__k6IeO span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .createUser_tableheadlight__zJuDZ th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .createUser_dashboard__17yXH {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .createUser_cont2__AUUWk {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .createUser_sectionright__v-V2q {
    float: unset !important;
  }
  .createUser_dashboard__17yXH {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .createUser_cont2__AUUWk {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .createUser_bodythemelight__xGFCq, .createUser_bodythemedark__kzglF {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .createUser_exer_modal_contain__KDFCs .createUser_modal-dialog__yVYfJ {
    max-width: 1055px;
  }
  .createUser_delPopContainer__ernWk .createUser_modal-dialog__yVYfJ {
    max-width: 350px;
  }
}
#createUser_addform__c-1fM {
  width: 100%;
  border-radius: 5px;
  margin-top: 30px;
  padding-bottom: 30px;
}
#createUser_addform__c-1fM #createUser_addheading__l\\+Q6E {
  font-size: 18px;
  margin-bottom: 20px;
}
#createUser_addform__c-1fM .createUser_inputbox1__X2UXw {
  padding: 10px;
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #0f1824;
  color: #fff;
}
#createUser_addform__c-1fM .createUser_inputbox1__X2UXw:-webkit-autofill,
#createUser_addform__c-1fM .createUser_inputbox1__X2UXw:-webkit-autofill:focus {
  -webkit-transition: background-color 0s 600000s, color 0s 600000s !important;
  transition: background-color 0s 600000s, color 0s 600000s !important;
}
#createUser_addform__c-1fM input:-webkit-autofill,
#createUser_addform__c-1fM input:-webkit-autofill:focus {
  background-color: #0f1824 !important;
}
#createUser_addform__c-1fM .createUser_dateinputbox__il7dU {
  background-color: #F5F6FA;
  border-radius: 5px;
  width: 100%;
  color: #1d1d1d;
  font-size: 14px;
}
#createUser_addform__c-1fM .createUser_dateinputbox1__k6IeO {
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #0f1824;
  color: #60677e;
}
#createUser_addform__c-1fM .createUser_formbtn__7DbRY {
  background-color: #131F43;
  color: white;
  border: none;
  width: 100px;
  font-size: 16px;
  padding: 11px;
  border-radius: 5px;
  margin-right: 10px;
}
#createUser_addform__c-1fM .createUser_formbtn__7DbRY:hover {
  background-color: rgba(37, 105, 109, 0.864);
}
#createUser_addform__c-1fM .createUser_resetbtn__wCOLc {
  margin-left: 10px;
  background-color: rgba(180, 184, 192, 0.3882352941);
  color: #212529;
  border: none;
  width: 100px;
  font-size: 16px;
  padding: 11px;
  border-radius: 5px;
}
#createUser_addform__c-1fM .createUser_resetbtn__wCOLc:hover {
  background-color: rgba(37, 105, 109, 0.864);
  color: #fff;
}
#createUser_addform__c-1fM ::placeholder {
  font-size: 14px;
  color: #60677e;
}
#createUser_addform__c-1fM .createUser_labeltext__vHsyR {
  color: #1d1d1d;
  font-size: 14px;
  font-weight: 500;
}
#createUser_addform__c-1fM .createUser_eyeicon__LLaA6 {
  margin-left: -30px;
  cursor: pointer;
}
#createUser_addform__c-1fM .createUser_arrowback__lG5yY {
  float: right;
  background-color: #dde2eb;
  padding: 10px;
  color: #39979d;
  cursor: pointer;
  border-radius: 3px;
}
#createUser_addform__c-1fM .createUser_arrowback__lG5yY:hover {
  background-color: #39979d;
  color: #fff;
}

@media only screen and (max-width: 600px) {
  #createUser_dashboardcont2__nLo41 {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/users/createUser.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,2BAAA;EACA,gBAAA;ACxEF;;AD0EA;EACE,yBAAA;EACA,yBAhGO;EAiGP,kBAAA;ACvEF;;ADyEA;;;EAGE,yBAlEoB;ACJtB;;ADwEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACrEF;;ADwEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAxHO;EAyHP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACnEF;;AD4EA;EACE,YAAA;ACzEF;;AD4EA;EACE,sBA5FY;ACmBd;;AD4EA;;CAAA;AAGA;EACE,sBAnGY;EAoGZ,iBAAA;ACzEF;;AD2EA;EACE,yBAlHgB;EAmHhB,iBAAA;ACxEF;;AD2EA;;CAAA;AAGA;EACE,sBA/GY;ACuCd;;AD2EA;EACE,yBA9HgB;ACsDlB;;AD0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACvEF;;AD0EA;;CAAA;AAGA;EACE,sBAnIY;AC4Dd;;ADyEA;EACE,yBAjJgB;AC2ElB;;ADyEA;;CAAA;AAGA;EACE,yBAAA;ACtEF;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EACE,sBAAA;ACtEF;;ADyEA;EACE,yBAlKsB;EAmKtB,cA7KkB;ACuGpB;;ADwEA;EACE,sCAAA;EACA,sBAAA;EACA,yBA5Mc;ACuIhB;;ADwEA;EACE,yBAAA;ACrEF;;ADwEA;EACE,sBAAA;EACA,yBArNc;ACgJhB;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,yBArMsB;EAsMtB,WA7LY;ACwHd;;ADwEA;;CAAA;AAGA;EACE,cAjMe;AC4HjB;;ADwEA;EACE,cArMe;ACgIjB;;ADwEA;;CAAA;AAGA;EACE,sBA/MY;EAgNZ,YAAA;ACrEF;;ADwEA;EACE,yBA/NgB;EAgOhB,WArNY;EAsNZ,YAAA;ACrEF;;ADuEA;EACE,cAtNe;ACkJjB;;ADuEA;;CAAA;AAGA;EACE,yBA7Qc;EA8Qd,8BAAA;ACpEF;;ADsEA;EACE,WApOY;ACiKd;;ADqEA;;EAEE,0BAAA;AClEF;;ADoEA;;EAEE,0BAAA;ACjEF;;ADmEA;EACE,kBAAA;AChEF;;ADkEA;EACE,kBAAA;AC/DF;;ADiEA;EACE,oCAAA;EACA,gCAAA;AC9DF;;ADiEA;EACE,yBAlPkB;EAmPlB,WA3PY;AC6Ld;;ADgEA;EACE,yBAAA;AC7DF;;AD+DA;EACE,iBAAA;AC5DF;;AD8DA;;EAEE,+BAAA;EACA,iBAAA;AC3DF;;AD6DA;EACE,sBAzQY;AC+Md;AD4DE;EACE,yBAAA;EACA,YAAA;AC1DJ;;AD6DA;EACC,0CAAA;EACC,cA/Qe;ACqNjB;AD4DE;EACE,yCAAA;EACA,YAAA;AC1DJ;;AD8DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,0BAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBA1SY;EA2SZ,yBAAA;EACA,qDAAA;AC1DF;;AD4DA;EACE,yBAvSkB;EAwSlB,yBAAA;EACA,eAAA;ACzDF;AD2DE;EACE,cAjTa;ACwPjB;;AD8DA;;CAAA;AAGA;EACE,yBAhUgB;ACqQlB;;AD8DA;EACE,yBAAA;EACA,yBAAA;AC3DF;;AD6DA;EACE,yBA/UoB;EAgVpB,yBAAA;AC1DF;;AD6DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAnVY;ACyRd;;AD6DA;EACE,yBA/UkB;ACqRpB;;AD8DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAhWY;ACqSd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAzWY;AC8Sd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAlXY;ACuTd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBA3XY;ACgUd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;;;;EAIE,WAtYY;AC2Ud;;AD8DA;;CAAA;AAGA;EACE,qCAAA;AC3DF;;AD6DA;EACE,eAAA;AC1DF;;AD4DA;EACE,cAhZe;ACuVjB;;AD6DA;;CAAA;AAGA;EACE,sBAAA;AC1DF;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,yBApbkB;EAqblB,WApaY;AC0Wd;;AD4DA;EACE,yBAxbkB;EAyblB,WAxaY;AC+Wd;;AD4DA;EACE,6BAAA;ACzDF;;AD4DA;EACE,2BAAA;ACzDF;;AD4DA;EACE,yBArckB;AC4YpB;;AD4DA;EACE,yBAxcwB;AC+Y1B;;AD4DA;EACE,WA5bY;EA6bZ,6BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,yBAndkB;AC0ZpB;;AD6DA;EACE,yBAldgB;ACwZlB;;AD6DA;EACE,eAAA;EACA,gBA/fc;EAggBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cA7fc;EA8fd,gBAAA;AC1DF;;AD4DA;;;EAGE,yBAngBc;EAogBd,WAvdY;AC8Zd;;AD4DA;EACE,gBAAA;EACA,YAAA;EACA,WA7dY;EA8dZ,yBAzfY;EA0fZ,YAAA;EACA,eAAA;EACA,gBAphBc;AC2dhB;;AD4DA;EACE,yBAhgBY;ACucd;;AD2DA;EACE,yBAzfkB;ACicpB;;AD0DA;EACE,yBA3fwB;ACoc1B;;AD0DA;EACE,cAjgBiB;AC0cnB;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACxDF;;AD2DA;EACE,WA1fY;EA2fZ,yBAthBY;EAuhBZ,YAAA;ACxDF;;AD2DA;EACE,QAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBA1hBW;EA2hBX,WAvgBY;EAwgBZ,eAAA;EACA,gBA5jBc;EA6jBd,YAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBApiBW;EAqiBX,WAjhBY;EAkhBZ,eAAA;EACA,gBAtkBc;EAukBd,YAAA;ACxDF;;AD2DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACxDF;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACxDF;;AD2DA;;;EAGE,yBA1jBW;EA2jBX,WAviBY;EAwiBZ,YAAA;ACxDF;;AD2DA;EACE,yBAzlBc;ACiiBhB;;AD2DA;;;EAGE,yBA/lBc;ACuiBhB;;AD2DA;EACE,MAAA;ACxDF;;AD6DA;EACE,aAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,mBAAA;AC1DF;;AD6DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC1DF;;AD6DA;EACE,UAAA;AC1DF;;AD6DA;EACE,yCA9lBc;EA+lBd,cAnmBkB;ACyiBpB;;AD6DA;EACE,aAvmBkB;AC6iBpB;;AD6DA;EACE,yBAnmBgB;ACyiBlB;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlmBY;ACwiBd;;AD6DA;;EAEE,yBAxnBkB;EAynBlB,WAxmBY;AC8iBd;;AD4DA;EACE,6BAAA;EACA,yBAAA;EACA,WA7mBY;ACojBd;;AD4DA;EACE,yBA1nBsB;EA2nBtB,WAlnBY;ACyjBd;;AD4DA;;;EAGE,WAxnBY;AC+jBd;;AD4DA;;EAEE,yBAxoBgB;EAyoBhB,WA9nBY;ACqkBd;;AD4DA;EACE,yBAhrBO;ACunBT;;AD4DA;EACE,eAjpBgB;ACwlBlB;;AD4DA;EACE,YA1oBY;ACilBd;;AD4DA;;EAEE,sBAAA;ACzDF;;AD4DA,iBAAA;AAUA;EACE;IACE,gBAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EClEF;EDoEA;IACE,2BAAA;IACA,gBAAA;EClEF;AACF;ADoEA;EACC;;KAAA;AChED;ADoEA;EACE;IACE,uBAAA;EClEF;EDoEA;IACE,6BAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClEF;EDoEA;IACE,kBAAA;EClEF;AACF;ADqEA;EACE;IACI,iBAAA;ECnEJ;EDqEA;IACI,gBAAA;ECnEJ;AACF;AApsBA;EAEI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAqsBJ;AAnsBI;EACI,eAAA;EACA,mBAAA;AAqsBR;AAlsBI;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDiCc;EChCd,WD0CM;AC0pBd;AAjsBI;;EAEI,4EAAA;EAAA,oEAAA;AAmsBR;AAhsBI;;EAEE,oCAAA;AAksBN;AAhsBI;EACI,yBDjBC;ECkBD,kBAAA;EACA,WAAA;EACA,cD2BM;EC1BN,eAAA;AAksBR;AAhsBI;EACI,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDSc;ECRd,cDqBS;AC6qBjB;AA/rBI;EACI,yBD2BW;EC1BX,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAisBR;AA/rBQ;EACI,2CDkBS;AC+qBrB;AA9rBI;EACI,iBAAA;EACA,mDAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAgsBR;AA9rBI;EACI,2CAAA;EACA,WAAA;AAgsBR;AA7rBI;EACI,eAAA;EACA,cDbS;AC4sBjB;AA7rBI;EACI,cDlBM;ECmBN,eAAA;EACA,gBAAA;AA+rBR;AA7rBM;EACE,kBAAA;EACA,eAAA;AA+rBR;AA5rBM;EACE,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AA8rBR;AA5rBU;EACE,yBAAA;EACA,WAAA;AA8rBZ;;AA1rBE;EACE;IACI,wBDdI;ICeJ,UDdG;ICeH,kBAAA;IACA,aDtBW;ECmtBjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 310px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n#addform{\n\n    width: 100%;\n    border-radius: 5px;\n    margin-top: 30px;\n    padding-bottom:30px;\n\n    #addheading{\n        font-size: 18px;\n        margin-bottom: 20px;\n    }\n\n    .inputbox1{\n        padding: 10px;\n        border: none;\n        border-radius: 5px;\n        width: 100%;\n        background-color: $darkTheme_darkBlue;\n        color: $white-color;\n         \n    }\n    .inputbox1:-webkit-autofill,\n    .inputbox1:-webkit-autofill:focus{\n        transition: background-color 0s 600000s, color 0s 600000s !important;\n         \n    }\n    input:-webkit-autofill,\n    input:-webkit-autofill:focus {\n      background-color: $darkTheme_darkBlue !important;\n    }\n    .dateinputbox{\n        background-color: $mainBg;\n        border-radius: 5px;\n        width: 100%;\n        color: $black-color;\n        font-size: 14px;\n    }\n    .dateinputbox1{\n        border: none;\n        border-radius: 5px;\n        width: 100%;\n        background-color: $darkTheme_darkBlue;\n        color: $lightthemetext;\n    }\n\n    .formbtn{\n        background-color: $primary-btncolor;\n        color: white;\n        border: none;\n        width: 100px;\n        font-size: 16px;\n        padding: 11px;\n        border-radius: 5px;\n        margin-right: 10px;\n\n        &:hover{\n            background-color: $secondary-btncolor;\n        }\n    }\n    .resetbtn{\n        margin-left: 10px;\n        background-color: #b4b8c063;\n        color: #212529;\n        border: none;\n        width: 100px;\n        font-size: 16px;\n        padding: 11px;\n        border-radius: 5px;\n    }\n    .resetbtn:hover{\n        background-color: rgba(37, 105, 109, 0.864);\n        color:#fff;\n    }\n    \n    ::placeholder{\n        font-size: 14px;\n        color: $lightthemetext;\n    }\n    .labeltext{\n        color: $black-color;\n        font-size: 14px;\n        font-weight: 500;\n     }\n      .eyeicon{\n        margin-left: -30px;\n        cursor: pointer;\n      }\n\n      .arrowback{\n        float: right;\n        background-color: #dde2eb;\n        padding: 10px;\n        color: #39979d;\n        cursor: pointer;\n        border-radius: 3px;\n\n          &:hover{\n            background-color: #39979d;\n            color: #fff;\n          }\n      }\n  }\n  @media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `createUser_dashboard__17yXH`,
	"dashboardContain": `createUser_dashboardContain__frg-z`,
	"bodythemedark": `createUser_bodythemedark__kzglF`,
	"cont2": `createUser_cont2__AUUWk`,
	"top_header": `createUser_top_header__5x0WP`,
	"top_header_inner": `createUser_top_header_inner__WgBlR`,
	"footer": `createUser_footer__r8ySe`,
	"bodythemelight": `createUser_bodythemelight__xGFCq`,
	"headerthemelight": `createUser_headerthemelight__9RK3i`,
	"headerthemedark": `createUser_headerthemedark__rbDM+`,
	"menuthemelight": `createUser_menuthemelight__EgxpM`,
	"menuthemedark": `createUser_menuthemedark__e-R6+`,
	"menulinklight": `createUser_menulinklight__Dv14u`,
	"menulinkdarkSelected": `createUser_menulinkdarkSelected__84zB7`,
	"menulinklightSelected": `createUser_menulinklightSelected__34KWF`,
	"menulinkdark": `createUser_menulinkdark__gEw+k`,
	"sub_arrow": `createUser_sub_arrow__owL-H`,
	"headinglight": `createUser_headinglight__pb5IY`,
	"headingdark": `createUser_headingdark__+wZmd`,
	"searchboxlight": `createUser_searchboxlight__it2cD`,
	"searchboxdark": `createUser_searchboxdark__zk723`,
	"tableheadlight": `createUser_tableheadlight__zJuDZ`,
	"tableheaddark": `createUser_tableheaddark__93g9w`,
	"table": `createUser_table__+vT8B`,
	"table-borderless": `createUser_table-borderless__zuaEC`,
	"left-section": `createUser_left-section__m6jeo`,
	"tablebodylight": `createUser_tablebodylight__RQHFo`,
	"tablebodydark": `createUser_tablebodydark__+wUQe`,
	"paginationlight": `createUser_paginationlight__vk0cl`,
	"paginationdark": `createUser_paginationdark__Xw1eA`,
	"formthemelight": `createUser_formthemelight__GNCil`,
	"formthemedark": `createUser_formthemedark__c2wJu`,
	"viewformlight": `createUser_viewformlight__5iQFa`,
	"permissionboxlight": `createUser_permissionboxlight__Xbi1l`,
	"permissionboxdark": `createUser_permissionboxdark__tZnnH`,
	"errormsgclr": `createUser_errormsgclr__fZqt+`,
	"graphclrlight": `createUser_graphclrlight__w4ooJ`,
	"graphclrdark": `createUser_graphclrdark__BbVKi`,
	"card1bglight": `createUser_card1bglight__0e+GH`,
	"card1bgdark": `createUser_card1bgdark__olYL6`,
	"card2bglight": `createUser_card2bglight__vgbXZ`,
	"card2bgdark": `createUser_card2bgdark__rXsmA`,
	"card3bglight": `createUser_card3bglight__WUTme`,
	"card3bgdark": `createUser_card3bgdark__hI9mR`,
	"card4bglight": `createUser_card4bglight__1+mIM`,
	"card4bgdark": `createUser_card4bgdark__1zDPP`,
	"actionbtnlight": `createUser_actionbtnlight__DmVva`,
	"actionbtndark": `createUser_actionbtndark__gMi4o`,
	"profiledropdownlight": `createUser_profiledropdownlight__2lQzy`,
	"profiledropdowndark": `createUser_profiledropdowndark__Mvb9k`,
	"settingsection": `createUser_settingsection__JFGnn`,
	"addform": `createUser_addform__c-1fM`,
	"savebtn": `createUser_savebtn__uS9j+`,
	"profile_conatiner": `createUser_profile_conatiner__RVAU1`,
	"ag-theme-alpine": `createUser_ag-theme-alpine__d2lH0`,
	"ag-row": `createUser_ag-row__GzqWr`,
	"formbtn": `createUser_formbtn__7DbRY`,
	"resetbtn": `createUser_resetbtn__wCOLc`,
	"addBtn": `createUser_addBtn__2U3kk`,
	"addbtnlight": `createUser_addbtnlight__sZAtb`,
	"addbtndark": `createUser_addbtndark__WGuk8`,
	"cust_addBtn": `createUser_cust_addBtn__Z-wC0`,
	"deleteBtn": `createUser_deleteBtn__E04aD`,
	"confirmBtn": `createUser_confirmBtn__3LX0U`,
	"delPopContainer": `createUser_delPopContainer__ernWk`,
	"modal-body": `createUser_modal-body__MHQGK`,
	"delet_icon": `createUser_delet_icon__fXzxB`,
	"arrowback": `createUser_arrowback__lG5yY`,
	"drpdwn_btn": `createUser_drpdwn_btn__DhdKo`,
	"empname": `createUser_empname__ZhmHW`,
	"navitemli": `createUser_navitemli__3afjv`,
	"tabnavli": `createUser_tabnavli__rjxZW`,
	"settingsgeneral": `createUser_settingsgeneral__lu7P9`,
	"settingslinks": `createUser_settingslinks__RRBrS`,
	"dropdown_menu_contain": `createUser_dropdown_menu_contain__YGsrZ`,
	"dropdown_item": `createUser_dropdown_item__mYmtG`,
	"profile_arrrow_dwn": `createUser_profile_arrrow_dwn__WFPyZ`,
	"dateinputbox1": `createUser_dateinputbox1__k6IeO`,
	"sectionright": `createUser_sectionright__v-V2q`,
	"exer_modal_contain": `createUser_exer_modal_contain__KDFCs`,
	"modal-dialog": `createUser_modal-dialog__yVYfJ`,
	"addheading": `createUser_addheading__l+Q6E`,
	"inputbox1": `createUser_inputbox1__X2UXw`,
	"dateinputbox": `createUser_dateinputbox__il7dU`,
	"labeltext": `createUser_labeltext__vHsyR`,
	"eyeicon": `createUser_eyeicon__LLaA6`,
	"dashboardcont2": `createUser_dashboardcont2__nLo41`
};
export default ___CSS_LOADER_EXPORT___;
